export default "__VITE_ASSET__MvUcnXwZ__"